export default __webpack_public_path__ + "static/media/SaveThisJob-MarketingPage.fb8c4a35.png";